import PaymentLogCard from "@/components/payment/PaymentLogCard";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/Card";
import { usePayment } from "@/hooks/usePayment";
import * as shared from "@/styles/shared";
import { Loader2, RefreshCw, XCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import * as styles from "./PaymentHistory.styles";

const PaymentHistory = () => {
  const { paymentLogs, paymentLogsLoading, paymentLogsError, loadPaymentLogs } = usePayment();
  const { t } = useTranslation("payment");

  return (
    <Card variant="glass" className={styles.card}>
      <CardHeader className={styles.header}>
        <CardTitle className={styles.title}>{t("paymentHistory")}</CardTitle>
      </CardHeader>
      <CardContent className={styles.content}>
        {paymentLogsLoading ? (
          <div className={styles.loadingContainer}>
            <Loader2 className={styles.loadingSpinner} />
            <span className={styles.loadingText}>{t("historyLoading")}</span>
          </div>
        ) : paymentLogsError ? (
          <div className={styles.errorContainer}>
            <XCircle className={styles.errorIcon} />
            <p className={shared.errorText}>{t("historyFailedTitle")}</p>
            <p className={styles.errorMessage}>{paymentLogsError}</p>
            <button onClick={loadPaymentLogs} className={styles.retryButton}>
              <RefreshCw className={styles.retryIcon} /> {t("historyRetry")}
            </button>
          </div>
        ) : !paymentLogs.length ? (
          <div className={styles.emptyContainer}>
            <p className={shared.muted}>{t("historyEmpty")}</p>
          </div>
        ) : (
          <div className={styles.historyList}>
            {paymentLogs.map((log) => (
              <PaymentLogCard key={log.id} log={log} />
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default PaymentHistory;
